// src/components/TaskViewPage/TaskViewPage.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "../../gmanewstyle.module.css";
import logoimage from "../assets/Group -2.png";
import { format } from "date-fns";
import PortalSidebar from "../PortalSidebar/PortalSidebar";

const TaskDetailPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Default sidebar state based on device width
  useEffect(() => {
  const handleResize = () => {
    const desktop = window.innerWidth >= 1024;
    setIsDesktop(desktop);

    // Only force closed when moving to smaller screens.
    // On desktop, keep whatever state the user last chose.
    if (!desktop) {
      setSidebarOpen(false);
    }
  };

  handleResize();
  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);

  const { id, buildingId } = useParams();
  const navigate = useNavigate();
  const buildingname = localStorage.getItem("buildingName");
  const [task, setTask] = useState(null);
  const [timeline, setTimeline] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  const fmt = (d) => {
    if (!d) return "—";
    try {
      return format(new Date(d), "dd MMM yyyy HH:mm");
    } catch {
      return "—";
    }
  };
  const [userAccess, setUserAccess] = useState([]);
  const [loadingAccess, setLoadingAccess] = useState(true);

  useEffect(() => {
    const fetchUserAccess = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
        return;
      }

      try {
        const decoded = JSON.parse(atob(token.split(".")[1]));
        const { email, contact_id, firstname, lastname, name } = decoded || {};

        // Set display name safely
        const fullName =
          firstname && lastname
            ? `${firstname} ${lastname}`
            : name
            ? name
            : email || "User";

        setDisplayName(fullName);

        if (!email) {
          setLoadingAccess(false);
          return;
        }

        const resp = await fetch(
          "https://portal.gmacc.co.za/api/contact/determine-access/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ email, contact_id }),
          }
        );

        const data = await resp.json();
        if (resp.ok) {
          setUserAccess(data.access || []);
        }
      } catch (err) {
        console.error("Failed to fetch access:", err);
      } finally {
        setLoadingAccess(false);
      }
    };

    fetchUserAccess();
  }, [navigate]);
  useEffect(() => {
  function handleClick(e) {
    // On desktop/laptop, only the burger should control the sidebar
    if (isDesktop) return;

    const sidebar = document.getElementsByClassName(styles.sidebar)[0];
    const hamburger = document.getElementsByClassName(styles.menuBtn)[0];

    if (!sidebar || !hamburger) return;

    const clickedInsideSidebar = sidebar.contains(e.target);
    const clickedHamburger = hamburger.contains(e.target);

    if (sidebarOpen && !clickedInsideSidebar && !clickedHamburger) {
      setSidebarOpen(false);
    }
  }

  document.addEventListener("click", handleClick);
  return () => document.removeEventListener("click", handleClick);
}, [sidebarOpen, isDesktop]);


  useEffect(() => {
    document.title = "Task Detail";
    const token = localStorage.getItem("token");
    if (!token) return navigate("/");

    (async () => {
      try {
        const headers = { Authorization: `Bearer ${token}` };
        const [tRes, nRes] = await Promise.all([
          fetch(`https://portal.gmacc.co.za/api/task/${id}/`, { headers }),
          fetch(`https://portal.gmacc.co.za/api/task/${id}/timeline/`, {
            headers,
          }),
        ]);
        if (!tRes.ok || !nRes.ok) throw new Error();
        const taskData = await tRes.json();
        const notesData = await nRes.json();
        setTask(taskData);
        setTimeline(Array.isArray(notesData.value) ? notesData.value : []);
      } catch {
        setError("Could not load task.");
      } finally {
        setLoading(false);
      }
    })();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className={styles.page}>
        <div className={styles.shell}>
          <main className={styles.contentArea}>
            <div className={styles.panel}>
              <div className={styles.loadingContainer}>
                <div className={styles.loadingImage}></div>
                <p className={styles.loadingText}>Loading...</p>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
  if (error) {
    return <p className={styles.errorText}>{error}</p>;
  }

  // Sort timeline by createdon desc
  const sortedTimeline = [...timeline].sort(
    (a, b) => new Date(b.createdon) - new Date(a.createdon)
  );

  const summaryFields = [
    ["Subject", "cj_subjectt"],
    ["Type", "cj_tickettype@OData.Community.Display.V1.FormattedValue"],
    ["Status", "cj_progresss@OData.Community.Display.V1.FormattedValue"],
    ["Created", "createdon"],
    [
      "Linked Building",
      "_cj_linkedbuildingg_value@OData.Community.Display.V1.FormattedValue",
    ],
    [
      "Assigned To",
      "_cj_assignedtowhom_value@OData.Community.Display.V1.FormattedValue",
    ],
  ];

  return (
    <div className={styles.page}>
      <header className={styles.topbar}>
        <div className={styles.topbarLeft}>
          <img src={logoimage} alt="GMA Logo" className={styles.topLogo} />

          {/* HAMBURGER: opens/closes sidebar */}
          <button
            type="button"
            className={styles.menuBtn}
            onClick={() => setSidebarOpen((v) => !v)}
          >
            ☰
          </button>

          <h1 className={styles.topTitle}>Task Detail</h1>
        </div>

        {/* USER CHIP: opens dropdown */}
        <div
          className={styles.userChip}
          onClick={() => {
            navigate("/user-profile");
          }}
          style={{ cursor: "pointer" }}
        >
          <span className={styles.statusDot}></span>
          <span className={styles.userName}>{displayName} ▾</span>
        </div>
      </header>

      <div className={styles.shell}>
        <PortalSidebar
  activePortal="trustee"
  activeTab="buildings"
  userAccess={userAccess}
  loadingAccess={loadingAccess}
  sidebarOpen={sidebarOpen}
  ticketRole="trustee"
/>
        <main className={styles.contentArea}>
          <div className={styles.panel}>
            {/* SUMMARY TABLE */}
            <div className={styles.paymentHeaderCard}>
              <div className={styles.card}>
                <button
                  className={styles.paymentBackBtn}
                  onClick={() => navigate(-1)}
                >
                  Back
                </button>
                {/* TITLE */}
                <h1 className={styles.paymentHeaderTitle}>TASK SUMMARY</h1>

                {/* DIVIDER */}
                <div className={styles.paymentHeaderDivider} />

                {/* LABEL ROW — AUTO GRID */}
                <div
                  className={styles.paymentHeaderGridAuto}
                  style={{ "--col-count": summaryFields.length }}
                >
                  {summaryFields.map(([label]) => (
                    <div key={label} className={styles.paymentHeaderLabelItem}>
                      {label}:
                    </div>
                  ))}
                </div>

                {/* VALUE PILL — AUTO GRID */}
                <div className={styles.paymentHeaderValuePill}>
                  <div
                    className={styles.paymentHeaderGridAuto}
                    style={{ "--col-count": summaryFields.length }}
                  >
                    {summaryFields.map(([label, field]) => {
                      const raw = task[field];
                      const val = field === "createdon" ? fmt(raw) : raw ?? "—";

                      return (
                        <div
                          key={field}
                          className={styles.paymentHeaderValueItem}
                        >
                          {/* Linked Building clickable */}
                          {label === "Linked Building" &&
                          task._cj_linkedbuildingg_value ? (
                            <span
                              className={styles.gmaLink}
                              onClick={() =>
                                navigate(
                                  `/building-info/${task._cj_linkedbuildingg_value}`
                                )
                              }
                            >
                              {val}
                            </span>
                          ) : (
                            val
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            {/* DESCRIPTION + TIMELINE */}
            <div className={styles.paymentCardGrid}>
              {/* DESCRIPTION */}
              <div className={styles.paymentCardDark}>
                <h2>Description</h2>
                <p className={styles.htmlContent}>
                  {task.cj_detaileddescriptionn || "—"}
                </p>
              </div>

              {/* TIMELINE NOTES */}
              <div className={styles.paymentCard}>
                <h2>Timeline</h2>
                {sortedTimeline.length === 0 ? (
                  <p className={styles.infoText}>No notes available.</p>
                ) : (
                  <div className={styles.responsiveTableWrapper}>
                    <table className={styles.dataTable}>
                      <thead>
                        <tr>
                          <th className={styles.topTableHeader}>Date</th>
                          <th className={styles.topTableHeader}>Note</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedTimeline.map((note) => (
                          <tr
                            key={note.annotationid}
                            className={styles.topTableRow}
                          >
                            <td className={styles.topTableCell}>
                              {fmt(note.createdon)}
                            </td>
                            <td
                              className={styles.topTableCell}
                              dangerouslySetInnerHTML={{
                                __html: note.notetext,
                              }}
                            />
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default TaskDetailPage;
